import gql from 'graphql-tag';

import {
  TraversalDirection,
  useRunArtifactDagQuery,
} from '../../../generated/graphql';
import {formatArtifactDagQuery, LineageQueryType} from '../utils';
import {ArtifactLineageDagFragment} from './artifactDag.query';

export const RUN_ARTIFACT_DAG_QUERY = gql`
  query RunArtifactDAG(
    $projectName: String!
    $entityName: String!
    $runName: String!
    $limit: Int!
    $filterGeneratedArtifacts: Boolean!
    $clusterSize: Int
    $directLineage: Boolean
    $traversalDirection: TraversalDirection
    $baseGraphNodeIDs: [String!]
  ) {
    project(name: $projectName, entityName: $entityName) {
      id
      run(name: $runName) {
        id
        artifactLineageDag(
          limit: $limit
          filterGeneratedArtifacts: $filterGeneratedArtifacts
          clusterSize: $clusterSize
          directLineage: $directLineage
          traversalDirection: $traversalDirection
          baseGraphNodeIDs: $baseGraphNodeIDs
        ) {
          ...GraphDataFragment
        }
      }
    }
    ${ArtifactLineageDagFragment}
  }
`;

export function useRunArtifactDagQueryCaller(
  entityName: string,
  projectName: string,
  runName: string,
  limit: number,
  filterGeneratedArtifacts: boolean,
  clusterSize?: number,
  directLineage?: boolean,
  traversalDirection?: TraversalDirection,
  baseGraphNodeIDs?: string[]
) {
  const {data, loading} = useRunArtifactDagQuery({
    variables: {
      entityName,
      projectName,
      runName,
      limit,
      filterGeneratedArtifacts,
      clusterSize,
      directLineage,
      traversalDirection,
      baseGraphNodeIDs,
    },
    skip: entityName === '',
  });

  const {dag, limited} = formatArtifactDagQuery(data, LineageQueryType.RUN);

  return {
    dag,
    limited,
    loading,
  };
}
